import React, { useState } from 'react';
import { Link, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const Logo = () => (
  <div className="flex items-center gap-1">
    <span className="text-white font-black text-3xl tracking-tight lowercase">
      site<span className="text-[#A3FF12]">factory</span>
    </span>
    <svg width="22" height="22" viewBox="0 0 24 24" className="text-[#A3FF12] ml-0.5" fill="none">
      <path d="M4 4h16M4 12h16M4 20h10" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
    </svg>
  </div>
);

const Register = () => {
  const { register, user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'hunter' });
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/app" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      await register(form.email, form.password, form.name, form.role);
      navigate('/app');
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Error al registrar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4 py-12">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_20%,rgba(163,255,18,0.08),transparent_50%)] pointer-events-none"/>
      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-10"><Logo /></div>
        <div className="bg-[#0a0a0a] border border-white/10 rounded-3xl p-8">
          <h1 className="text-3xl font-black text-white">Crear cuenta</h1>
          <p className="text-white/50 text-sm mt-2">Date de alta para empezar a gestionar emplazamientos.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="text-white/80 text-sm font-semibold">Nombre</label>
              <input required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})}
                className="w-full mt-1 bg-black border border-white/15 text-white rounded-xl px-4 py-3 focus:outline-none focus:border-[#A3FF12]" placeholder="Tu nombre"/>
            </div>
            <div>
              <label className="text-white/80 text-sm font-semibold">Email</label>
              <input type="email" required value={form.email} onChange={(e) => setForm({...form, email: e.target.value})}
                className="w-full mt-1 bg-black border border-white/15 text-white rounded-xl px-4 py-3 focus:outline-none focus:border-[#A3FF12]" placeholder="tu@empresa.com"/>
            </div>
            <div>
              <label className="text-white/80 text-sm font-semibold">Contraseña</label>
              <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({...form, password: e.target.value})}
                className="w-full mt-1 bg-black border border-white/15 text-white rounded-xl px-4 py-3 focus:outline-none focus:border-[#A3FF12]" placeholder="Mínimo 6 caracteres"/>
            </div>
            <div>
              <label className="text-white/80 text-sm font-semibold">Rol</label>
              <select value={form.role} onChange={(e) => setForm({...form, role: e.target.value})}
                className="w-full mt-1 bg-black border border-white/15 text-white rounded-xl px-4 py-3 focus:outline-none focus:border-[#A3FF12]">
                <option value="hunter">Hunter (capta emplazamientos)</option>
                <option value="gestor">Gestor (negociaciones)</option>
                <option value="admin">Admin (todo)</option>
              </select>
            </div>
            {err && <div className="bg-red-500/10 border border-red-500/30 text-red-300 text-sm rounded-lg px-3 py-2">{err}</div>}
            <button type="submit" disabled={loading}
              className="w-full bg-[#A3FF12] text-black font-black py-3 rounded-xl hover:bg-[#b8ff3a] transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
              {loading && <Loader2 className="animate-spin" size={18}/>} Crear cuenta
            </button>
          </form>
          <div className="text-white/50 text-sm mt-6 text-center">
            ¿Ya tienes cuenta? <Link to="/login" className="text-[#A3FF12] font-semibold hover:underline">Inicia sesión</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
